import React from "react";

import { useTranslation, Trans } from "react-i18next";

function DepositTake () {

    const { t } = useTranslation();
      
    return(
        <div className="relative overflow-hidden">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto pt-[100px] xl:pt-[160px]">  
                <div className="flex flex-col xl:flex-row justify-between">
                    <div className="xl:w-[394px] xl:flex flex-col gap-[20px] hidden">
                        <div className="border border-[#28282880] flex items-center justify-center py-[20px]">
                            <p className="inter font-[600]">{t('home.30')}</p>
                        </div>      
                        <div className="border border-[#28282880] flex items-center justify-center py-[43px]">
                            <p className="inter font-[600]">{t('home.31')}</p>
                        </div>   
                        <div className="flex items-center justify-center py-[43px]">
                            <svg className="absolute" xmlns="http://www.w3.org/2000/svg" width="394" height="110" viewBox="0 0 394 110" fill="none">
                                <path d="M393.5 109.5V0.5H0.5V59.793L50.207 109.5H393.5Z" stroke="#282828" stroke-opacity="0.5"/>
                            </svg>
                            <p className="inter font-[600]">{t('home.32')}</p>
                        </div>
                    </div>
                    <div className="flex flex-col xl:items-center xl:max-w-[384px]">
                        <p className="merriweather spantext italic font-[700] xl:text-[40px] text-[32px]"><Trans>{t('home.33')}</Trans></p>
                        <p className="merriweather spantext italic font-[700] xl:text-[30px] text-[32px]"><Trans>{t('home.34')}</Trans></p>
                        <p className="xl:max-w-[487px] inter fdfd text-[14px] xl:text-[16px] font-[300] mt-[25px] xl:text-center"><Trans>{t('home.35')}</Trans></p>
                        <p className="xl:max-w-[487px] inter fdfd text-[14px] xl:text-[16px] font-[300] mt-[15px] xl:text-center"><Trans>{t('home.36')}</Trans></p>
                    </div>
                    <div className="xl:w-[394px] xl:flex flex-col gap-[20px] hidden">
                        <div className="border border-[#28282880] flex items-center justify-center py-[20px]">
                            <p className="inter font-[600]">{t('home.37')}</p>
                        </div>      
                        <div className="border border-[#28282880] flex items-center justify-center py-[43px]">
                            <p className="inter font-[600]">{t('home.38')}</p>
                        </div>   
                        <div className="flex items-center justify-center py-[43px]">
                            <svg className="absolute" xmlns="http://www.w3.org/2000/svg" width="394" height="110" viewBox="0 0 394 110" fill="none">
                                <path d="M393.5 0.5V59.793L343.793 109.5H0.5V0.5H393.5Z" stroke="#282828" stroke-opacity="0.5"/>
                            </svg>
                            <p className="inter font-[600]">{t('home.39')}</p>
                        </div>
                    </div>
                    <div className="flex flex-wrap xl:hidden mt-[30px] gap-[12px]">
                        <div className="border border-[#28282880] flex items-center justify-center w-[140px] flex-grow py-[15px]">
                            <p className="inter font-[600] text-[14px]">{t('home.30')}</p>
                        </div>
                        <div className="border border-[#28282880] flex items-center justify-center w-[140px] flex-grow py-[15px]">
                            <p className="inter font-[600] text-[14px]">{t('home.31')}</p>
                        </div>
                        <div className="border border-[#28282880] flex items-center justify-center w-[140px] flex-grow py-[15px]">
                            <p className="inter font-[600] text-[14px]">{t('home.32')}</p>
                        </div>
                        <div className="border border-[#28282880] flex items-center justify-center w-[140px] flex-grow py-[15px]">
                            <p className="inter font-[600] text-[14px]">{t('home.37')}</p>
                        </div>
                        <div className="border border-[#28282880] flex items-center justify-center w-[140px] flex-grow py-[15px]">
                            <p className="inter font-[600] text-[14px]">{t('home.38')}</p>
                        </div>
                        <div className="border border-[#28282880] flex items-center justify-center w-[140px] flex-grow py-[15px]">
                            <p className="inter font-[600] text-[14px]">{t('home.39')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DepositTake;